export const DIOfferingsMappedToEquipmentTypes = {
  "DI-CH": "Chiller,HeatPumpChiller",
  "DI-AHU": "AHU",
}

export const EXCLUDED_OFFERINGS = {
  AN: "AN",
  AM: "AM",
  GF: "GF",
  TS: "TS",
  TC: "TC",
  RA: "RA"
}

export const OFFERING_STATUS = {
  "Approved": "Approved",
  "Expired": "Expired"
}


export const DIOfferings = ["CAP", "BP"]
export const OFFERING_STATUS_TO_DISPLAY = [OFFERING_STATUS.Approved, OFFERING_STATUS.Expired];
export const DI_TAB_V2_ALLOWED_EQUIP_TYPES = [];
export const DI_TAB_ALLOWED_EQUIP_TYPES = ["VRF-System", "VRF-IDU", "VRF-ODU"];

export const CHECKED_OFFERINGS = ["BP", "CAP", "DI-AHU", "DI-CH", "DI-VRF"]
export const ENABLING_EHR_REPORT_OFFERINGS = ["BP", "CAP", "DI-AHU", "DI-CH"]
export const ENABLING_CPR_REPORT_OFFERINGS = ["BP", "CAP", "DI-CH"]
export const ENABLING_AHUPR_REPORT_OFFERINGS = ["BP", "CAP", "DI-AHU"]
export const ENABLING_DI_REPORT_OFFERINGS = ["BP", "CAP", "DI-AHU", "DI-CH"]
export const ENABLING_ALARM_EVENTS_REPORT_OFFERINGS = ["BP", "CAP", "DI-CH"]
export const ENABLING_SA_REPORT_OFFERINGS = ["BP", "CAP", "DI-CH"]
